<header id="headadmin">
    <app-header></app-header>
    <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Paramétricas variables cargue información CHV</h5>
    </div>
    <div class="card-body">
      <div class="col-auto">
        <a type="a" class="btn btn-secondary" (click)="Regresar()" style="color: white;">
          Volver
        </a>
      </div>
      <br>
      <div class="table-responsive overflow-scroll" style="align-content: center;">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" class="text-center" style="background-color: lightgrey;">Variable</th>
              <th scope="col" class="text-center" style="background-color: lightgrey;">Subitems</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of ParametricasCHV | paginate:{ itemsPerPage: 5, currentPage: page }">
              <td style="text-align: center;">
                <a type="a" class="btn btn-light" id="fuentes" (click)="EditarVariable(s)" data-bs-toggle="modal" data-bs-target="#VerVariable">{{s.nombre}}</a>
              </td>
              <td style="text-align: center;">
                <a *ngIf="s.subitem" type="a" class="btn btn-light" id="fuentes">Si</a>
                <a *ngIf="!s.subitem" type="a" class="btn btn-light" id="fuentes">No</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row justify-content-center">
        <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
      </div>
    </div>
  </div>
</body>

<!--Modal-->
<div class="modal fade bd-example-modal-lg" id="VerVariable" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header" style="background-color: #be0c4d;">
            <h5 class="modal-title" id="exampleModalLabel" style="color: white;">Variable de Reporte : {{NombreParametricaEdit}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form>
                <div class="modal-body" *ngIf="ParametricaEditVaria.orden == 1">
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <label><b>Nombre variable: </b></label>
                        </div>
                        <div class="col-auto">
                            <input class="form-control" name="nombrevar1" [(ngModel)]="ParametricaEditVaria.nombre">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" style="margin-top: 5px;" (click)="EditarParametrica()">Actualizar</button>
                        </div>
                    </div>
                    <br>
                    <div class="container-fluid overflow-scroll" style="border: solid; border-color: grey;">
                        <div class="col-auto">
                            <button type="button" class="btn btn-secondary" style="margin-top: 5px;" (click)="NuevoItemSuper()">Nuevo Item</button>
                        </div>
                        <br>
                        <table class="table table-bordered">
                            <thead>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Opción</th>
                            </thead>
                            <tbody>
                            <tr *ngFor="let s of SuperintendenciasList | paginate:{ itemsPerPage: 5, currentPage: page2 }">
                                <td class="col-1"><input class="form-control" name="{{s.codigo}}" [(ngModel)]="s.codigo" [disabled]="true"></td>
                                <td class="col-8"><input class="form-control" name="{{s.nombre}}" [(ngModel)]="s.nombre" oninput="this.value = this.value.replace(/[^0-9a-zA-Z' ']/g, '')"></td>
                                <td class="col-1" style="text-align: center;"><a type="button" class="fa fa-check-square-o"
                                style="color: green; margin: auto;" (click)="EditarItem(s)"></a></td>
                            </tr>
                            <tr *ngIf="NuevaVariable">
                                <td><input class="form-control" name="nuevasupercodigo1" [(ngModel)]="NuevaVariableParametrica.codigo"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '')" maxlength="99"></td>
                                <td><input class="form-control" name="nuevasupernombre1" [(ngModel)]="NuevaVariableParametrica.nombre"
                                  maxlength="50" oninput="this.value = this.value.replace(/[^0-9a-zA-Z' ']/g, '')"></td>
                                <td class="col-2" style="text-align: center;"><a type="button" class="fa fa-check-square-o"
                                style="color: green; margin: auto;" (click)="GuardarItemSuper(NuevaVariableParametrica)" [disabled]="ActiBtnGuardar"></a></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-center">
                        <div class="col-auto"><pagination-controls (pageChange)="page2 = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
                        </div>
                    </div>
                </div>
                <div class="modal-body" *ngIf="ParametricaEditVaria.orden == 2">
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <label><b>Nombre variable: </b></label>
                        </div>
                        <div class="col-auto">
                            <input class="form-control" name="nombrevar2" [(ngModel)]="ParametricaEditVaria.nombre">
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" style="margin-top: 5px;" (click)="EditarParametrica()">Actualizar</button>
                        </div>
                    </div>
                    <br>
                    <div class="container-fluid overflow-scroll" style="border: solid; border-color: grey;">
                        <div class="col-auto">
                            <button type="button" class="btn btn-secondary" style="margin-top: 5px;" (click)="NuevoItemSuper()">Nuevo Item</button>
                        </div>
                        <br>
                        <table class="table table-bordered">
                            <thead>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Codigo Superintendencia</th>
                                <th>Opción</th>
                            </thead>
                            <tbody>
                            <tr *ngFor="let s of TipoEntidadList | paginate:{ itemsPerPage: 5, currentPage: page3 }">
                                <td class="col-1"><input class="form-control" name="{{s.codigo}}" [(ngModel)]="s.codigo" disabled></td>
                                <td class="col-8"><input class="form-control" name="{{s.nombre}}" [(ngModel)]="s.nombre"></td>
                                <td class="col-8"><input class="form-control" name="{{s.codsuper}}" [(ngModel)]="s.codsuper" oninput="this.value = this.value.replace(/[^0-9a-zA-Z' ']/g, '')"></td>
                                <td class="col-1" style="text-align: center;"><a type="button" class="fa fa-check-square-o"
                                    style="color: green; margin: auto;" (click)="EditarItem(s)"></a></td>
                            </tr>
                            <tr *ngIf="NuevaVariable">
                                <td><input class="form-control" name="NuevaTEcodigo" [(ngModel)]="NuevaVariableParametrica.codigo"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '')" maxlength="99"></td>
                                <td><input class="form-control" name="NuevaTEnombre" [(ngModel)]="NuevaVariableParametrica.nombre"
                                  maxlength="50" oninput="this.value = this.value.replace(/[^0-9a-zA-Z' ']/g, '')"></td>
                                <td><input class="form-control" name="NuevaTEcodsuper" [(ngModel)]="NuevaVariableParametrica.codsuper"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '')" maxlength="99"></td>
                                <td class="col-2" style="text-align: center;"><a type="button" class="fa fa-check-square-o"
                                    style="color: green; margin: auto;" (click)="GuardarItemSuper(NuevaVariableParametrica)" [disabled]="ActiBtnGuardar"></a></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-center">
                        <div class="col-auto"><pagination-controls (pageChange)="page3 = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
                        </div>
                    </div>
                </div>
                <div class="modal-body" *ngIf="ParametricaEditVaria.orden != 1 && ParametricaEditVaria.orden != 2 && ParametricaEditVaria.nombre != 'Divipola'">
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <label><b>Nombre variable: </b></label>
                        </div>
                        <div class="col-auto">
                            <input class="form-control" name="nombrevar3" [(ngModel)]="ParametricaEditVaria.nombre"><!-- [disabled]="CodigoDisabled"-->
                        </div>
                    </div>
                    <br>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" style="margin-top: 5px;" (click)="EditarParametrica()">Actualizar</button>
                        </div>
                    </div>
                    <br>
                    <div *ngIf="ParametricaEditVaria.subitem" class="container-fluid overflow-scroll" style="border: solid; border-color: grey;">
                        <div class="col-auto">
                            <button type="button" class="btn btn-secondary" style="margin-top: 5px;" (click)="NuevoItemSuper()">Nuevo Item</button>
                        </div>
                        <br>
                        <table class="table table-bordered">
                            <thead>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Opción</th>
                            </thead>
                            <tbody>
                            <tr *ngFor="let s of VariablesPara | paginate:{ itemsPerPage: 5, currentPage: page4 }">
                                <td class="col-1"><input class="form-control" name="{{s.codigo}}" [(ngModel)]="s.codigo" [disabled]="true"></td>
                                <td class="col-8"><input class="form-control" name="{{s.nombre}}" [(ngModel)]="s.nombre" oninput="this.value = this.value.replace(/[^0-9a-zA-Z<>=' ']/g, '')"></td>
                                <td class="col-1" style="text-align: center;"><a type="button" class="fa fa-check-square-o"
                                style="color: green; margin: auto;" (click)="EditarItem(s)"></a></td>
                            </tr>
                            <tr *ngIf="NuevaVariable">
                                <td><input class="form-control" name="NuevaVariablecodigo3" [(ngModel)]="NuevaVariableParametrica.codigo"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '')" maxlength="99"></td>
                                <td><input class="form-control" name="NuevaVariablenombre3" [(ngModel)]="NuevaVariableParametrica.nombre" maxlength="50" oninput="this.value = this.value.replace(/[^0-9a-zA-Z<>=' ']/g, '')"></td>
                                <td class="col-2" style="text-align: center;"><a type="button" class="fa fa-check-square-o"
                                style="color: green; margin: auto;" (click)="GuardarItemSuper(NuevaVariableParametrica)" [disabled]="ActiBtnGuardar"></a></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-center">
                            <div class="col-auto"><pagination-controls (pageChange)="page4 = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
                        </div>
                    </div>
                </div>
                <div class="modal-body  overflow-scroll" *ngIf="ParametricaEditVaria.nombre == 'Divipola'">
                    <table class="table table-bordered">
                        <thead>
                        <th>No.</th>
                        <th>Código Departamento</th>
                        <th>Departamento</th>
                        <th>Código Municipio</th>
                        <th>Municipio</th>
                        </thead>
                        <tbody>
                        <tr *ngFor="let s of ListadoDivipola | paginate:{ itemsPerPage: 10, currentPage: page1 }">
                            <td>{{s.id}}</td>
                            <td>{{s.coddepto}}</td>
                            <td>{{s.departamento}}</td>
                            <td>{{s.codmpio}}</td>
                            <td>{{s.nommpio}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="row justify-content-center">
                    <div class="col-auto"><pagination-controls (pageChange)="page1 = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
                    </div>
                </div>
            </form>
            <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="ngOnInit()" #closeModalnuevaVariable>Cancelar</button>
            <!--button type="button" class="btn btn-primary" (click)="crearNuevaVariableParametrica()">Crear</button-->
            </div>
        </div>
    </div>
</div>
